import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import type { Node } from "interfaces/schemas";
import * as identify from "utils/treeUtils";

export const getScrollToIndex = (
  node: NodeApi<Node>,
  isPastingConfig: boolean = false,
) => {
  if (isPastingConfig) {
    return getProductScrollTo(node);
  }
  const lastDecendant = getLastDecendant(node);
  return lastDecendant.rowIndex !== null ? lastDecendant.rowIndex + 1 : 0;
};

const getLastDecendant = (node: NodeApi<Node>) => {
  if (node.children?.length && node.children?.length > 0) {
    return getLastDecendant(node.children[node.children.length - 1]);
  }
  return node;
};

const getProductScrollTo = (node: NodeApi<Node>) => {
  if (node.children?.length && node.children?.length > 0) {
    let index = 0;
    for (let i = 0; i < node.children.length; i += 1) {
      if (!identify.isAnyProduct(node.children[i].data)) {
        break;
      }
      index = i;
    }
    return (node?.children?.[index]?.rowIndex ?? 0) + 1;
  }
  return node.rowIndex ?? 0;
};
